import toast from "react-hot-toast";
import {
  FORGOT_PASSWORD,
  FORGOT_PASSWORD_FAIL,
  FORGOT_PASSWORD_SUCCESS,
  LOGIN,
  LOGIN_FAIL,
  LOGIN_SUCCESS,
  REGISTER,
  REGISTER_FAIL,
  REGISTER_SUCCESS,
  RESET_PASSWORD_FAIL,
  RESET_PASSWORD,
  RESET_PASSWORD_SUCCESS,
  PROFILE_DETAILS,
  PROFILE_DETAILS_SUCCESS,
  PROFILE_DETAILS_FAIL,
  UPDATE_PROFILE_DETAILS,
  UPDATE_PROFILE_DETAILS_SUCCESS,
  UPDATE_PROFILE_DETAILS_FAIL,
  EMAIL_VERIFY,
  EMAIL_VERIFY_SUCCESS,
  EMAIL_VERIFY_FAIL,
  UPLOAD,
  UPLOAD_SUCCESS,
  UPLOAD_FAIL,
} from "../actions/AuthActions";
import { cookie } from "../cookies/cookies";

const initialState = {
  isLoading: false,
  isUploading: false,
  isMeLoading: false,
  isError: false,
  isSuccess: false,
  message: "",
  authList: [],
  registerData: [],
  forgotPassword: [],
  resetPassword: [],
  profileDetails: {},
  uploadSuccess: '',
  emailVerifyMessage: "",
};
const authReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case LOGIN: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case LOGIN_SUCCESS: {
      toast.success(payload?.message);
      cookie.set("token", payload.data?.tokens.access.token);
      const user = payload?.data?.user;
      cookie.set("user_type", user?.user_type);
      if (user?.user_type === "admin") {
        window.location.href = "/admin/dashboard";
      }
      else if(user?.user_type === "personal_shopper"){
        window.location.href = "/personal-shopper/products";
      } 
       else {
        window.location.href = "/dashboard";
      }
      return {
        ...state,
        authList: payload,
        isLoading: false,
        isSuccess: true,
        isError: false,
      };
    }

    case LOGIN_FAIL: {
      toast.error(payload?.error?.data?.message);
      return {
        ...state,
        isLoading: false,
        isSuccess: false,
        isError: true,
        message: payload?.error.data.message,
      };
    }

    //============= register ==================

    case REGISTER: {
      return {
        ...state,
        isLoading: true,
        isSuccess: false,
      };
    }

    case REGISTER_SUCCESS: {
      // toast.success(payload?.message || "Registration successful!", { duration: 3000 });
      toast.success("You have registered successfully.", { duration: 1500 });
      setTimeout(() => {
        window.location.href = "/login";
      }, 1500);
      return {
        ...state,
        registerData: payload.user,
        isLoading: false,
        isSuccess: true,
      };
    }

    case REGISTER_FAIL: {
      toast.error(payload?.error?.data?.message);
      return {
        ...state,
        isLoading: false,
        errorMessage: payload,
        isSuccess: false,
      };
    }

    //  =========== forgot===============

    case FORGOT_PASSWORD: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case FORGOT_PASSWORD_SUCCESS: {
      toast.success(payload?.message);
      // setTimeout(() => {
      //   window.location.reload();
      // }, 1500);

      return {
        ...state,
        resetPassword: payload.data,
        isLoading: false,
      };
    }
    case FORGOT_PASSWORD_FAIL: {
      toast.error(payload?.error?.data?.message);
      return {
        ...state,
        isLoading: false,
      };
    }

    // ========== reset Password =========

    case RESET_PASSWORD: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case RESET_PASSWORD_SUCCESS: {
      toast.success(payload?.message, { duration: 4000 });
      setTimeout(() => {
        window.location.href = "/login";
      }, 1500);

      return {
        ...state,
        forgotPassword: payload.data,
        isLoading: false,
      };
    }
    case RESET_PASSWORD_FAIL: {
      toast.error(payload?.error?.data?.message);
      return {
        ...state,
        isLoading: false,
      };
    }

    case PROFILE_DETAILS: {
      return {
        ...state,
        isMeLoading: true,
      };
    }

    case PROFILE_DETAILS_SUCCESS: {
      return {
        ...state,
        profileDetails: payload.data?.user,
        isMeLoading: false,
      };
    }

    case PROFILE_DETAILS_FAIL: {
      return {
        ...state,
        isMeLoading: false,
      };
    }
    case EMAIL_VERIFY: {
      return {
        ...state,
        isMeLoading: true,
      };
    }

    case EMAIL_VERIFY_SUCCESS: {
      toast.success(payload?.message, { duration: 4000 });
      return {
        ...state,
        emailVerifyMessage: payload.message,
        isMeLoading: false,
      };
    }

    case EMAIL_VERIFY_FAIL: {
      return {
        ...state,
        isMeLoading: false,
      };
    }

    case UPDATE_PROFILE_DETAILS: {
      return {
        ...state,
        isLoading: true,
      };
    }

    case UPDATE_PROFILE_DETAILS_SUCCESS: {
      toast.success(payload?.message);
      return {
        ...state,
        profileDetails: {
          ...state.profileDetails,
          ...payload.data?.user,
        },
        isLoading: false,
      };
    }

    case UPDATE_PROFILE_DETAILS_FAIL: {
      toast.error(payload?.error?.data?.message);
      return {
        ...state,
        isLoading: false,
      };
    }
    case UPLOAD: {
      return {
        ...state,
        isUploading: true,
      };
    }

    case UPLOAD_SUCCESS: {
      toast.success(payload?.message);
      return {
        ...state,
        uploadSuccess: payload.url,
        isUploading: false,
      };
    }

    case UPLOAD_FAIL: {
      toast.error(payload?.error?.data?.message);
      return {
        ...state,
        isUploading: false,
      };
    }

    default: {
      return { ...state };
    }
  }
};
export default authReducer;
